import React, {
  createContext,
  memo,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { Maybe } from 'types/graphqlTypes'
import { Five9Data } from './types'
import { fetchFive9Data } from './utils'

interface IConnectedPhoneNumberContextState {
  five9Data: Maybe<Five9Data>
}

export const ConnectedPhoneNumberContext = createContext<IConnectedPhoneNumberContextState>({
  five9Data: null,
})

export const ConnectedPhoneNumberProvider = memo<PropsWithChildren<{}>>(({ children }) => {
  const [five9Data, setFive9Data] = useState<Maybe<Five9Data>>(null)

  /**
   * @description Fetch and store Five9 data on mount so that downstream ConnectedPhoneNumber components are able to
   *    consume it.
   */
  useEffect(() => {
    const init = async () => {
      const five9Data = await fetchFive9Data()
      setFive9Data(five9Data)
    }

    init()
  }, [])

  const state: IConnectedPhoneNumberContextState = useMemo(
    () => ({
      five9Data,
    }),
    [five9Data]
  )

  return (
    <ConnectedPhoneNumberContext.Provider value={state}>
      {children}
    </ConnectedPhoneNumberContext.Provider>
  )
})

export const useConnectedPhoneNumberContext = () => useContext(ConnectedPhoneNumberContext)
